/** V2 `Kicker` (kit.jsx:37-40) — the only uppercase micro-label in V2, a page kicker — over the hub `Kicker`'s V2 voice. */
import React from 'react';
import { Kicker as HubKicker } from '../clients/hub/designSystem';

export interface KickerProps {
  children?: React.ReactNode;
  tone?: string;
  size?: number;
  style?: React.CSSProperties;
}

export function Kicker({ children, tone = 'var(--indigo)', size = 9.5, style }: KickerProps): React.ReactElement {
  return <HubKicker voice="v2" color={tone} size={size} style={style}>{children}</HubKicker>;
}

export default Kicker;
